import { Injectable } from '@angular/core';
import { Route, CanLoad, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, UrlSegment, Router } from '@angular/router';

import { Observable } from 'rxjs';
import { RmmValidateUserService } from '../services/rmm-validate-user.service';

@Injectable()
export class PERMISSION_GUARD implements CanActivate, CanLoad {

    constructor(
        private validateUserService: RmmValidateUserService,
        public router: Router
    ) {}

    //canLoad is used for Module Basis Auth
    canLoad(route: Route, segments: UrlSegment[]): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
        if (route.path === '/') {
            return true;
        }
        // Match the route being loaded (same as old mappingRoute check), not router.url which can be stale here
        const rmmPath = `rmm/${route.path}`;
        if (this.validateUserService.checkValidateMethod(rmmPath)) {
            return true;
        }
        return this.createDashboardUrlTree(this.router.url || `/${rmmPath}`);
    }

    //canActivate is used for Component Based Auth
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
        if (route.routeConfig?.path === '/') {
            return true;
        }
        if (this.validateUserService.checkValidateMethod(state.url)) {
            return true;
        }
        // Return UrlTree instead of router.navigate() — navigate + return false causes a loading hang
        return this.createDashboardUrlTree(state.url);
    }

    private createDashboardUrlTree(currentUrl: string): UrlTree {
        const [pathOnly, queryString] = currentUrl.split('?');
        const dashboardPath = pathOnly.replace(/rmm\/[^/]*/, 'rmm/dashboard');
        return this.router.parseUrl(queryString ? `${dashboardPath}?${queryString}` : dashboardPath);
    }

}
